import { PayloadAction } from '@reduxjs/toolkit';
import { AppState } from './appSlice';
import { getConfigBaseUrl, getIAMBaseUrl } from '../services/apiService';
import { apiCall, createApiThunk } from '../utils/api';

interface SetDarkThemePayload {
  isDark: boolean;
}

export const authLogoutThunk = createApiThunk('AUTH_LOGOUT', apiCall);
export const getSessionTimeoutConfigThunk = createApiThunk('GET_SESSION_TIMEOUT_CONFIG', apiCall);
export const getMaxSecuritiesConfigThunk = createApiThunk('GET_MAX_SECURITIES_CONFIG', apiCall);

export const setDarkThemeReducer = (
  state: AppState,
  action: PayloadAction<SetDarkThemePayload>,
) => {
  state.darkTheme = action.payload.isDark;
};

export const setIsLoadingReducer = (state: AppState, action: PayloadAction<boolean>) => {
  state.isLoading = action.payload;
};

export const authLogout = () => async (dispatch: AppDispatch) => {
  await dispatch(authLogoutThunk({ url: `${getIAMBaseUrl()}/auth/logout`, method: 'GET' }));
};

export const getSessionTimeoutConfig = () => (dispatch: AppDispatch) => {
  return dispatch(
    getSessionTimeoutConfigThunk({
      url: `${getConfigBaseUrl()}/v1/bny/config/timeout`,
      method: 'GET',
    }),
  );
};

export const getMaxSecuritiesConfig =
  (configKeyMaxSecurities: string) => (dispatch: AppDispatch) => {
    return dispatch(
      getMaxSecuritiesConfigThunk({
        url: `${getConfigBaseUrl()}/v1/bny/basket/config-data?name=${configKeyMaxSecurities}`,
        method: 'GET',
      }),
    );
  };
